module.exports = __webpack_public_path__ + "static/media/icon-live.3eaec02b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-live.svg
// module id = ./src/assets/images/icon-live.svg
// module chunks = 0